export var StoreModulesName;
(function (StoreModulesName) {
    // session
    StoreModulesName["CURRENT_USER"] = "currentUser";
    // demandes financement
    StoreModulesName["AGGREGATIONS"] = "aggregations";
    StoreModulesName["TOTAL_DEMANDES_FINANCEMENT"] = "totalDemandesFinancement";
    StoreModulesName["TOTAL_SHARED_DEMANDES_FINANCEMENT"] = "totalSharedDemandesFinancement";
    StoreModulesName["DEMANDES_FINANCEMENT"] = "demandesFinancement";
    StoreModulesName["SHARED_DEMANDES_FINANCEMENT"] = "sharedDemandesFinancement";
    StoreModulesName["LATEST_DEMANDES_FINANCEMENT"] = "latestDemandesFinancement";
    StoreModulesName["LATEST_SHARED_DEMANDES_FINANCEMENT"] = "latestSharedDemandesFinancement";
    StoreModulesName["LINKED_DEMANDES_FINANCEMENT"] = "linkedDemandesFinancement";
    StoreModulesName["PUBLIC_SETTINGS"] = "publicSettings";
    // opened demandes apprenants
    StoreModulesName["OPENED_AGGREGATIONS_APPRENANTS"] = "openedAggregationsApprenants";
    StoreModulesName["OPENED_TOTAL_DEMANDES_APPRENANTS"] = "openedTotalDemandesApprenants";
    StoreModulesName["OPENED_DEMANDES_APPRENANTS"] = "openedDemandesApprenants";
    StoreModulesName["OPENED_TOTAL_FILTERED_DEMANDES_APPRENANTS"] = "openedTotalFilteredDemandesApprenants";
    // closed demandes apprenants
    StoreModulesName["CLOSED_AGGREGATIONS_APPRENANTS"] = "closedAggregationsApprenants";
    StoreModulesName["CLOSED_TOTAL_DEMANDES_APPRENANTS"] = "closedTotalDemandesApprenants";
    StoreModulesName["CLOSED_DEMANDES_APPRENANTS"] = "closedDemandesApprenants";
    StoreModulesName["CLOSED_TOTAL_FILTERED_DEMANDES_APPRENANTS"] = "closedTotalFilteredDemandesApprenants";
    // contributions VEF with formation not started
    StoreModulesName["FORMATION_NOT_STARTED_CONTRIBUTIONS_VEF"] = "formationNotStartedContributionsVEF";
    StoreModulesName["FORMATION_NOT_STARTED_AGGREGATIONS_CONTRIBUTIONS_VEF"] = "formationNotStartedAggregationsContributionsVEF";
    StoreModulesName["FORMATION_NOT_STARTED_TOTAL_CONTRIBUTIONS_VEF"] = "formationNotStartedTotalContributionsVEF";
    StoreModulesName["FORMATION_NOT_STARTED_TOTAL_FILTERED_CONTRIBUTIONS_VEF"] = "formationNotStartedTotalFilteredContributionsVEF";
    // contributions VEF with formation already started
    StoreModulesName["FORMATION_ALREADY_STARTED_CONTRIBUTIONS_VEF"] = "formationAlreadyStartedContributionsVEF";
    StoreModulesName["FORMATION_ALREADY_STARTED_AGGREGATIONS_CONTRIBUTIONS_VEF"] = "formationAlreadyStartedAggregationsContributionsVEF";
    StoreModulesName["FORMATION_ALREADY_STARTED_TOTAL_CONTRIBUTIONS_VEF"] = "formationAlreadyStartedTotalContributionsVEF";
    StoreModulesName["FORMATION_ALREADY_STARTED_TOTAL_FILTERED_CONTRIBUTIONS_VEF"] = "formationAlreadyStartedTotalFilteredContributionsVEF";
})(StoreModulesName || (StoreModulesName = {}));
//# sourceMappingURL=store.js.map